import { useEffect } from "react";
import MultipleSelect from "../../../Components/CluppForms/MultipleSelect";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const SelectProductToCancel = ({ state, setState, field, setShowButtons }) => {
  if (state?.products?.length === 0) {
    setShowButtons(false);
  }
  return Boolean(state?.products?.length > 0) ? (
    <>
      <TitleHeaders
        title={"¿Qué deseas cancelar?"}
        subtitle={
          "Por favor, selecciona uno de tus vehículos o dispositivos asegurados."
        }
        isRequired={true}
      />
      <MultipleSelect
        options={state.products}
        state={state}
        setState={setState}
        field={field}
        isMultiple={true}
      />
    </>
  ) : (
  
      <p style={{textAlign: "center", fontSize: "16px"}}>Lo sentimos, no tienes productos actualmente para cancelar.</p>
   
  );
};

export default SelectProductToCancel;
